(() => {
  if (window.wvrComparisonInitialized) return;
  window.wvrComparisonInitialized = true;
  const initialize = scope => {
    scope.querySelectorAll('[data-wvr-comparison]').forEach(dialog => {
      if (dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      dialog.dataset.ready = 'true';
      const listeners = new AbortController();
      const inputs = [...dialog.querySelectorAll('[data-wvr-compare-select]')];
      const columns = [...dialog.querySelectorAll('[data-wvr-compare-column]')];
      const table = dialog.querySelector('[data-wvr-compare-table]');
      const status = dialog.querySelector('[data-wvr-compare-status]');
      const search = dialog.querySelector('[data-wvr-compare-search]');
      const choices = [...dialog.querySelectorAll('[data-wvr-compare-choice]')];
      const empty = dialog.querySelector('[data-wvr-compare-empty]');
      let activeFilter = 'all';
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      const filterChoices = () => {
        const query = normalize(search?.value.trim() || '');
        choices.forEach(choice => {
          choice.hidden = (activeFilter !== 'all' && choice.dataset.group !== activeFilter) || !normalize(choice.dataset.search || choice.textContent).includes(query);
        });
        if (empty) empty.hidden = choices.some(choice => !choice.hidden);
      };
      let priorOverflow;
      let opener;
      const update = () => {
        const selected = inputs.filter(input => input.checked).map(input => input.value);
        inputs.forEach(input => { input.disabled = selected.length >= 3 && !input.checked; });
        columns.forEach(column => { column.hidden = !selected.includes(column.dataset.wvrCompareColumn); });
        table.hidden = selected.length === 0;
        status.textContent = status.dataset.template.replace('{count}', selected.length);
        const selectedProducts = inputs.filter(input => input.checked).map(input => input.dataset.productId);
        document.querySelectorAll('[data-wvr-compare-count]').forEach(counter => {
          counter.textContent = String(selected.length);
          counter.hidden = selected.length === 0;
        });
        document.querySelectorAll('[data-wvr-compare-product]').forEach(button => {
          button.hidden = !inputs.some(input => input.dataset.productId === button.dataset.wvrCompareProduct);
          button.setAttribute('aria-pressed', String(selectedProducts.includes(button.dataset.wvrCompareProduct)));
        });
      };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-wvr-compare-open], [data-wvr-compare-product]');
        if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (document.querySelector('dialog[open]') || document.documentElement.classList.contains('js-drawer-open')) return;
        event.preventDefault();
        opener = trigger;
        let limitReached = false;
        if (trigger.hasAttribute('data-wvr-compare-product')) {
          const input = inputs.find(choice => choice.dataset.productId === trigger.dataset.wvrCompareProduct);
          if (!input) return;
          if (inputs.filter(choice => choice.checked).length < 3) input.checked = true;
          else limitReached = !input.checked;
          dialog.querySelectorAll('[data-wvr-compare-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.wvrCompareFilter === 'all')));
          activeFilter = 'all';
          if (search) search.value = '';
          filterChoices();
          update();
        }
        priorOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        dialog.querySelector('[data-wvr-compare-close]').focus();
        if (limitReached) status.textContent = status.dataset.limit;
      }, { signal: listeners.signal });
      dialog.querySelector('[data-wvr-compare-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = priorOverflow || '';
        if (!document.querySelector('dialog[open]') && !document.documentElement.classList.contains('js-drawer-open')) opener?.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
      inputs.forEach(input => input.addEventListener('change', () => {
        if (inputs.filter(choice => choice.checked).length > 3) input.checked = false;
        update();
      }));
      dialog.querySelectorAll('[data-wvr-compare-filter]').forEach(button => button.addEventListener('click', () => {
        dialog.querySelectorAll('[data-wvr-compare-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        activeFilter = button.dataset.wvrCompareFilter;
        filterChoices();
      }));
      search?.addEventListener('input', filterChoices);
      dialog.querySelector('[data-wvr-compare-reset]').addEventListener('click', () => {
        inputs.forEach(input => { input.checked = false; });
        update();
      });
      document.addEventListener('shopify:section:load', update, { signal: listeners.signal });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(dialog)) return;
        if (dialog.open) dialog.close();
        listeners.abort();
      }, { signal: listeners.signal });
      update();
    });
  };
  initialize(document);
  if (location.hash === '#wv-home-compare') {
    document.querySelector('[data-wvr-compare-open]')?.click();
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
